import React from "react";
import AccountTable from "./AccountTable";

export default function AccountPendingTable() {
  return <AccountTable isPending />;
}
